import { render, staticRenderFns } from "./CheckoutResultStep.vue?vue&type=template&id=e2a70250"
import script from "./CheckoutResultStep.vue?vue&type=script&lang=js"
export * from "./CheckoutResultStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports